import {
  FilterCondition,
  FilterGroup,
} from "./buildNycbsSearchFilters";
import { NYCBS_OUTCOME_CLASS_OTHERS } from "../table/utils/getNycbsOutcomeClassBadge";

/** Filter values that represent an unset pa_outcome_classification in BigQuery. */
export const EMPTY_PA_OUTCOME_CLASSIFICATION_FILTER_VALUES = [
  "",
  "null",
  "--",
  "None",
  "none",
  "nan",
  "NaN",
  "undefined",
];

/**
 * Builds a structured OR filter for Outcome Class when "Others" is selected.
 *
 * "Others" matches rows with an empty pa_outcome_classification.
 * Other selected values match their stored classification directly.
 *
 * @param selectedValues - Outcome Class values chosen in the filter sidebar
 * @return FilterGroup | null: OR group when "Others" is included, otherwise null
 */
export const buildNycbsOutcomeClassStructuredFilter = (
  selectedValues: string[],
): FilterGroup | null => {
  const includesOthers = selectedValues.includes(NYCBS_OUTCOME_CLASS_OTHERS);
  const classificationValues = selectedValues.filter(
    (value) => value !== NYCBS_OUTCOME_CLASS_OTHERS,
  );

  if (!includesOthers) {
    return null;
  }

  const children: (FilterCondition | FilterGroup)[] = [];

  if (classificationValues.length > 0) {
    children.push({
      type: "condition",
      field: "pa_outcome_classification",
      operator: "is_any_of",
      value: classificationValues,
    });
  }

  children.push({
    type: "condition",
    field: "pa_outcome_classification",
    operator: "is_any_of",
    value: EMPTY_PA_OUTCOME_CLASSIFICATION_FILTER_VALUES,
  });

  return {
    type: "group",
    operator: "or",
    children,
  };
};
